// See: https://github.com/antoniowd/react-jotform/blob/main/src/index.tsx
import React, { useEffect, useRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";

var createSource = (src, defaults) => {
  var url = new URL(src);

  if (defaults) {
    for (var _key of Object.keys(defaults)) {
      url.searchParams.set(_key, defaults[_key].toString());
    }
  }

  url.searchParams.set("isIframeEmbed", "1");
  return url.toString();
};

var isPermitted = (originUrl, whitelisted_domains) => {
  var url = document.createElement("a");
  url.href = originUrl;
  var hostname = url.hostname;
  var result = false;

  if (typeof hostname !== "undefined") {
    whitelisted_domains.forEach(function (element) {
      if (hostname.slice(-1 * element.length - 1) === ".".concat(element) || hostname === element) {
        result = true;
      }
    });
    return result;
  }

  return false;
};

export var JotForm = _ref => {
  var {
    src,
    defaults,
    title,
    scrolling = false,
    className,
    style = {
      minWidth: "100%",
      height: "539px",
      border: "none"
    }
  } = _ref;
  var iframeRef = useRef(null);

  var handleIframeMessage = event => {
    var _iframeRef$current;

    var iframe = iframeRef.current;
    var iframeContentWindow = iframeRef == null ? void 0 : (_iframeRef$current = iframeRef.current) == null ? void 0 : _iframeRef$current.contentWindow;

    if (typeof event.data === "object" || //checks if the iframe is the current iframe (for pages with 2 or more forms || iframes)
    event.source !== iframeContentWindow) {
      return;
    }

    var args = event.data.split(":");

    if (args.length > 2) {
      var _iframe$contentWindow;

      if (!iframe) {
        return;
      }

      switch (args[0]) {
        case "scrollIntoView":
          iframe.scrollIntoView();
          break;

        case "setHeight":
          iframe.style.height = args[1] + "px";
          break;

        case "collapseErrorPage":
          if (iframe.clientHeight > window.innerHeight) {
            iframe.style.height = window.innerHeight + "px";
          }

          break;

        case "reloadPage":
          window.location.reload();
          break;

        case "loadScript":
          if (!isPermitted(event.origin, ["jotform.com", "jotform.pro"])) {
            break;
          }

          var source = args[1];

          if (args.length > 3) {
            source = args[1] + ":" + args[2];
          }

          var script = document.createElement("script");
          script.src = source;
          script.type = "text/javascript";
          document.body.appendChild(script);
          break;

        case "exitFullscreen":
          if (window.document.exitFullscreen) {
            window.document.exitFullscreen();
          } // @ts-ignore
          else if (window.document.mozCancelFullScreen) {
            // @ts-ignore
            window.document.mozCancelFullScreen();
          } // @ts-ignore
          else if (window.document.mozCancelFullscreen) {
            // @ts-ignore
            window.document.mozCancelFullScreen();
          } // @ts-ignore
          else if (window.document.webkitExitFullscreen) {
            // @ts-ignore
            window.document.webkitExitFullscreen();
          } // @ts-ignore
          else if (window.document.msExitFullscreen) {
            // @ts-ignore
            window.document.msExitFullscreen();
          }

          break;
      }

      var isJotform = event.origin.indexOf("jotform") > -1;

      if (isJotform && (_iframe$contentWindow = iframe.contentWindow) != null && _iframe$contentWindow.postMessage) {
        var urls = {
          docurl: encodeURIComponent(document.URL),
          referrer: encodeURIComponent(document.referrer)
        };
        iframe.contentWindow.postMessage(JSON.stringify({
          type: "urls",
          value: urls
        }), "*");
      }
    }
  };

  useEffect(() => {
    if (window) {
      if (window.addEventListener) {
        window.addEventListener("message", handleIframeMessage, false);
      } // @ts-ignore
      else if (window.attachEvent) {
        // @ts-ignore
        window.attachEvent("onmessage", handleIFrameMessage);
      }
    }

    return () => {
      if (window) {
        if (window.removeEventListener) {
          window.removeEventListener("message", handleIframeMessage);
        } // @ts-ignore
        else if (window.detachEvent) {
          // @ts-ignore
          window.detachEvent("onmessage", handleIFrameMessage);
        }
      }
    };
  }, []);
  return /*#__PURE__*/_jsx("iframe", {
    ref: iframeRef,
    title: title // @ts-ignore
    ,
    allowtransparency: "true",
    allowFullScreen: true,
    allow: "geolocation; microphone; camera",
    src: createSource(src, defaults),
    frameBorder: "0",
    className: className,
    style: style,
    scrolling: scrolling ? "yes" : "no"
  });
};
//# sourceMappingURL=JotForm.js.map